export default {
  formatTimeoutMessage() {
    return '请求超时'
  },

  formatContextmenuClose() {
    return `关闭当前`
  },

  formatContextmenuCloseOthers() {
    return `关闭其它`
  },
  formatContextmenuClosePrev() {
    return `关闭左侧`
  },
  formatContextmenuCloseNext() {
    return `关闭右侧`
  },
  formatContextmenuCloseAll() {
    return `关闭所有`
  },
  formatContextmenuFullscreen() {
    return `全屏显示`
  },
  formatContextmenuRefresh() {
    return `重新加载`
  },
  formatContextmenuCenterActive() {
    return `回到当前`
  },
  formatContextmenuNewBlank() {
    return `新窗口打开`
  },
  formatSearchInputPlaceholder() {
    return `搜索标签页`
  },
  formatOpenedTabs() {
    return `打开的标签页`
  },
  formatRecentlyClosedTabs() {
    return `最近关闭的标签页`
  },
  formatSearchNoResults() {
    return `找不到任何结果`
  },
  formatTimeYear() {
    return `年前`
  },
  formatTimeMonths() {
    return `个月前`
  },
  formatTimeDays() {
    return `天前`
  },
  formatTimeHours() {
    return `小时前`
  },
  formatTimeMinutes() {
    return `分钟前`
  },
  formatTimeSeconds() {
    return `秒前`
  },
}
